// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2HrD0","col":"styles_col__Jcypz"};